export enum IbanOwnerType {
    OwnerAsker,
    OwnerLegalRepresentant,
}
